import { render } from "./TranslationAssetManager.vue?vue&type=template&id=669dea6c"
import script from "./TranslationAssetManager.vue?vue&type=script&lang=js"
export * from "./TranslationAssetManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__